import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import messages from '../messages';
import * as actions from '../actions';
import Modal from '../../../components/Modal';
import Button from '../../../components/Button';

import '../Edit/edit-modal-styles.css';

export const DeletionModalComponent = (props) => (
  <Modal
    open={props.openModal}
    onClose={props.closeModal}
    styleName="deletion-popup-modal"
  >
    <React.Fragment>
      <Modal.Header styleName="deletion-popup-header">
        <FormattedMessage {...messages.tileDeletionConfirm} />
      </Modal.Header>
      <Modal.Actions>
        <Button onClick={props.closeModal}>
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button
          id="deletion-popup-delete-button"
          primary
          onClick={() => {
            props.deleteMediaItem(props.selectedId);
            props.closeModal();
            props.resetModalState();
          }}
        >
          <FormattedMessage {...messages.delete} />
        </Button>
      </Modal.Actions>
    </React.Fragment>
  </Modal>
);

DeletionModalComponent.propTypes = {
  openModal: PropTypes.bool,
  closeModal: PropTypes.func,
  deleteMediaItem: PropTypes.func,
  selectedId: PropTypes.number,
  resetModalState: PropTypes.func,
};

export default connect(null, { ...actions })(DeletionModalComponent);
